import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { History } from 'lucide-react';
export function HistoryToggle({ currentCount, totalCount, showHistory, onToggle, noun = 'item', nounPlural, className }) {
    // Hide entirely when there's no history to expand. Every logical group
    // has exactly one row, so the toggle is meaningless.
    if (totalCount <= currentCount) return null;
    const plural = nounPlural ?? `${noun}s`;
    const historyDelta = totalCount - currentCount;
    // Two label modes — terse for the resting state, slightly more verbose
    // for the expanded state. Both fit within ~50 characters so the toggle
    // doesn't reflow the parent on click.
    const label = showHistory ? `Showing ${formatCount(totalCount)} ${plural} — hide history` : `${formatCount(currentCount)} of ${formatCount(totalCount)} ${plural} — show ${formatCount(historyDelta)} prior version${historyDelta === 1 ? '' : 's'}`;
    return /*#__PURE__*/ _jsxs("button", {
        type: "button",
        onClick: ()=>onToggle(!showHistory),
        className: clsx('inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-medium transition-colors', showHistory ? 'border-emerald-300 bg-emerald-50/60 text-emerald-800 hover:bg-emerald-50' : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900', className),
        "aria-pressed": showHistory,
        children: [
            /*#__PURE__*/ _jsx(History, {
                className: "h-3.5 w-3.5",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ _jsx("span", {
                children: label
            })
        ]
    });
}
function formatCount(n) {
    return n.toLocaleString();
}
